import catalogsService from '@/services/catalogsService'

/**
 * Valida el tenant con catalogs; si es válido redirige a app.mimente.com/{tenant}.
 * Si no existe, muestra 404 (evita soft 404 / redirect a login).
 */
const companyRegisterRedirectGuard = async (to, from, next) => {
  if (to.name !== 'landing-page-company-register') {
    return next()
  }

  const resilienciaDomain = process.env.VUE_APP_RESILIENCIA_DOMAIN
  const tenantName = to.params.tenantName

  if (!resilienciaDomain || !tenantName) {
    return next({ name: 'not-found', query: to.query, replace: true })
  }

  try {
    const { data } = await catalogsService.validateTenant({ tenant_name: tenantName })

    if (data.result?.data?.is_valid) {
      const base = String(resilienciaDomain).replace(/\/$/, '')
      const qs = window.location.search || ''
      window.location.replace(`${base}/${tenantName}${qs}`)
      return
    }
  } catch (_) {
    // Tenant inválido o error de red → 404
  }

  next({ name: 'not-found', query: to.query, replace: true })
}

export default companyRegisterRedirectGuard
